import { Box, Button, Typography, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { serviceTab } from "./constant";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useAuth } from "../../../contexts/AuthContext";
import { useEffect, useState } from "react";

const Services = () => {
  const navigate = useNavigate();

  const [serviceTabData, setServiceTabData] = useState(serviceTab);

  const handleNavigate = (route) => {
    navigate(route);
  };

  const { user } = useAuth();

  useEffect(() => {
    if (user && user["custom:orgName"] === "Electriva") {
      const filteredServiceTab = serviceTab.filter(
        (item) => item.key === "manual_swap"
      );
      setServiceTabData(filteredServiceTab);
    } else {
      setServiceTabData(serviceTab);
    }
  }, [user]);

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          mb: 3,
          textAlign: "left",
          fontWeight: 600,
          p: 1,
          pl: 4,
          borderRadius: 2,
          color: "#FFFFFF",
          background: {
            xs: "linear-gradient(45deg, #1DA7A7 50%, #FFFFFF 50%)",
            md: "linear-gradient(45deg, #1DA7A7 30%, #FFFFFF 30%)",
          },
          borderBottom: "1px solid #1DA7A7",
          borderBottomRightRadius: 0,
          lineHeight: "1.4",
        }}
      >
        Tools
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
          },
          gap: 3,
        }}
      >
        {serviceTabData.map((item) => (
          <Card
            key={item.key}
            sx={{
              borderRadius: 3,
              p: 2,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              transition: "0.3s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
              },
            }}
          >
            <CardContent sx={{ textAlign: "left" }}>
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: item.bgColor,
                  color: "#fff",
                  fontSize: 32,
                  mb: 2,
                }}
              >
                {item.icon}
              </Box>

              {/* Title */}
              <Typography
                variant="h6"
                fontWeight={600}
                gutterBottom
                sx={{ color: "#222" }}
              >
                {item.title}
              </Typography>

              {/* Description */}
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 2, minHeight: 50 }}
              >
                {item.description}
              </Typography>

              <Button
                fullWidth
                variant="contained"
                sx={{
                  background: item.buttonColor,
                  borderRadius: 3,
                  fontWeight: 600,
                  textTransform: "none",
                  border: "none",
                  p: 1.2,
                  "&:hover": {
                    border: "none",
                    opacity: 0.9,
                    background: item.buttonColor,
                  },
                }}
                onClick={() => handleNavigate(item.route)}
                endIcon={<KeyboardArrowRightIcon />}
              >
                {item.buttonText}
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default Services;
